"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventListener = function () {
  function EventListener(type) {
    _classCallCheck(this, EventListener);

    this.type = type;
    this.handler = null;
    this.callback = this.callback.bind(this);
  }

  _createClass(EventListener, [{
    key: "callback",
    value: function callback(event) {
      this.handler(event);
    }
  }, {
    key: "bind",
    value: function bind(node) {
      node.addEventListener(this.type, this.callback);
    }
  }, {
    key: "unbind",
    value: function unbind(node) {
      node.removeEventListener(this.type, this.callback);
    }
  }, {
    key: "update",
    value: function update(handler) {
      this.handler = handler;
    }
  }]);

  return EventListener;
}();

exports.default = EventListener;